module.exports = __webpack_public_path__ + "static/media/icons_cheville_pied.b7c20ec4.svg";